import { faFolder } from '@fortawesome/pro-solid-svg-icons/faFolder';
import { faRemove } from '@fortawesome/pro-solid-svg-icons/faRemove';
import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { IpmRqKeys } from '@ukpostbox/client-data/lib/Wrappers/ReactQuery/CacheKeys';
import { DropdownMenuEntry, useTranslation } from '@ukpostbox/frontend-framework';
import { useMailbox } from '../../Providers/NewMailboxProvider';
import { TagMenu } from '../../../_Global/Components/Tags/Menus/TagMenu';
import MailboxFolders from '../MailboxFolders';
import MailboxesActionsMenu from './MailboxesActionsMenu';
import { MailboxesSelectedMenuType } from './MailboxesMenusTypes';
import { useMailboxesStore } from '../../Providers/Stores/MailboxesStore';

function MailboxesSelectedMenu(props: MailboxesSelectedMenuType) {
	const { t } = useTranslation();
	const { parsedFilters, UpdateMailTags, ActionItem, RemoveItemsFromFolder } = useMailbox();

	const mailBoxInfo = useMailboxesStore((state) => state.mailBoxInfo);

	return (
		<>
			{props.showCustomFolderRemove && mailBoxInfo?.customFolderId && mailBoxInfo?.customFolderId !== -1 && (
				<>
					<DropdownMenuEntry
						title={t('customFolders.actions.removeFromFolder')}
						onClick={() => RemoveItemsFromFolder(mailBoxInfo.customFolderId as number)}
						icon={faRemove}
					/>
					<DropdownMenuEntry title={t('divider')} sectionDivider />
				</>
			)}

			<DropdownMenuEntry icon={faFolder} title={t('mailboxes.actions.moveToFolder')}>
				<MailboxFolders mailItemContext />
			</DropdownMenuEntry>

			<DropdownMenuEntry title='Divider' sectionDivider />

			{props.data && (
				<DropdownMenuEntry icon={faTag} title={t('mailboxes.actions.tagItems')} disableKeyboardEvents>
					<TagMenu
						data={props.data}
						dataKey={[IpmRqKeys.MAIL_BOX_KEY, parsedFilters]}
						updateCallback={(e: any, b: boolean) => UpdateMailTags(e, b)}
					/>
				</DropdownMenuEntry>
			)}

			<DropdownMenuEntry title='Divider' sectionDivider />

			<MailboxesActionsMenu
				isMenu
				actionCallback={(value: number) => (props.data ? ActionItem(props.data, value) : undefined)}
			/>
		</>
	);
}

export { MailboxesSelectedMenu };
